import { render } from "./ComponentMenuPe.vue?vue&type=template&id=2330c5d4"
import script from "./ComponentMenuPe.vue?vue&type=script&lang=js"
export * from "./ComponentMenuPe.vue?vue&type=script&lang=js"

import "./ComponentMenuPe.vue?vue&type=style&index=0&id=2330c5d4&lang=scss"

import exportComponent from "../../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__